import React from "react";
import "./DataStrategicMessagingSection.scss";
import ContentSection from "../components/ContentSection";
import SectionHeader from "../components/SectionHeader";
import TwoColumnLayout from "../components/TwoColumnLayout";
import { StatBlock } from "../components";

const DataStrategicMessagingSection: React.FC = () => {
  const leftContent = (
    <div className="data-strategic-messaging-section-content">
      <p>
        Data is a critical tool to guide programming, assist in strategic
        planning, and to convey your story to funders and partners. Several of
        the words, terms, and phases that we common language in the field and
        not under scrutiny. Through the process of gathering insights from the
        field for this report, we heard from organizations about how they are
        changing the way they describe their programs and services out of fear
        of losing a grant or opportunity. Thirty one percent of survey
        respondents stated they've changed the language they used in fundraising
        and marketing. Now more than ever, the field needs to be intentional
        about how it frames impact and communicates value.
      </p>
    </div>
  );

  const rightContent = (
    <div className="data-strategic-messaging-section-right-content">
      <StatBlock
        stat={31}
        statLabel="%"
        label="Respondents stated they’ve changed the language they used in fundraising and marketing."
      />
    </div>
  );

  return (
    <ContentSection className="data-strategic-messaging-section">
      <SectionHeader
        title="The Importance of Data and Strategic Messaging"
        description="Using data in storytelling"
      />
      <TwoColumnLayout leftContent={leftContent} rightContent={rightContent} />
      <h3>Takeaway</h3>
      <ol>
        <li>
          <strong>
            Be intentional about framing impact and communicating value.
          </strong>
          <p>
            Organizations are scrambling to determine how to articulate the
            value of their work. As we consider the pressures that many
            organizations face to redefine their work, we are all challenged to
            get to the bottom-line questions, that is, why are we doing what we
            do? The organizations that are best at answering this question, in a
            way that resonates with diverse stakeholder groups with diverse view
            points, are best positioned to navigate the uncertainty, and come
            out stronger on the other side.
          </p>
        </li>
      </ol>
    </ContentSection>
  );
};

export default DataStrategicMessagingSection;
